import { TemplatesListBody } from "modules/templates/schemas/templateModelSchemas";

const getSelectOptionFromTemplates = (templates: TemplatesListBody) => {
  const options = templates.map(({ id, name }) => ({
    value: id,
    label: `[${id}] ${name}`,
  }));

  return options;
};

export default getSelectOptionFromTemplates;
